export class UnresolvedVendorErrorCodeApiError extends Error {
  public constructor(
    public readonly status?: number,
    message = 'Unresolved vendor error code request failed',
  ) {
    super(message);
    this.name = 'UnresolvedVendorErrorCodeApiError';
  }
}
